import { ProfitByCustomerItemTypes } from './types';

import cn from './statistic.module.css';

const ProfitByCustomerItem = ({
  title,
  value,
  black,
}: ProfitByCustomerItemTypes): React.JSX.Element => (
  <div
    className={`${cn.profitByCustomerItem} ${
      black ? cn.profitByCustomerItemBlack : ''
    }`}
  >
    <div className={cn.profitByCustomerItemTitle}>{title}</div>
    <div className={cn.profitByCustomerItemValue}>{value}</div>
  </div>
);

export default ProfitByCustomerItem;
